import { MouseEvent } from 'react';
import { Identifier, useDataProvider, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { useMutation } from 'react-query';
import Button from '@mui/material/Button';
import FileCopyIcon from '@mui/icons-material/FileCopy';

type DuplicateLineItemResult = {
  data?: {
    id?: Identifier;
  };
  id?: Identifier;
};

export const DuplicateLineItemButton = ({ label = 'Duplicate' }: { label?: string }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const record = useRecordContext();
  const redirect = useRedirect();

  const { mutate, isLoading } = useMutation<DuplicateLineItemResult | undefined, Error>(
    () => dataProvider.duplicate({ resource: 'lineItems', id: record?.id }),
    {
      onSuccess: result => {
        const newId = result?.data?.id ?? result?.id;

        if (!newId) {
          notify('Duplication error: missing new line item id', { type: 'warning' });
          return;
        }

        notify('Duplicate line item created');
        redirect('edit', 'lineItems', newId);
      },
      onError: error => {
        notify(`Duplication error: ${error.message}`, { type: 'warning' });
      },
    },
  );

  if (!record?.id) {
    return null;
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    mutate();
  };

  return (
    <Button color="secondary" size="small" startIcon={<FileCopyIcon />} onClick={handleClick} disabled={isLoading}>
      {label}
    </Button>
  );
};
